/**
 * Cross-component coordination for `history.block` guards.
 *
 * Some flows (e.g. confirmed delete) intentionally redirect after a mutation,
 * but a sibling `history.block` guard cannot tell that the redirect was
 * deliberate and would otherwise pop a "leave page?" prompt over a page that
 * is already being torn down.
 *
 * The flow that owns the redirect calls `markNavigationIntentional()` just
 * before triggering the redirect. The next active block consumes the mark
 * via `consumeIntentionalNavigation()` and lets the navigation through.
 */

let intentionalNavCount = 0

export const markNavigationIntentional = () => {
  intentionalNavCount += 1
}

export const consumeIntentionalNavigation = () => {
  if (intentionalNavCount > 0) {
    intentionalNavCount -= 1
    return true
  }
  return false
}

export const resetNavigationGuardForTests = () => {
  intentionalNavCount = 0
}
